import React from 'react';
import { TopBar } from '../../components/TopBar';
import { FooterBar } from '../../components/FooterBar';
import { Button } from '../../components/Button';
import { useHistory } from 'react-router-dom';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { useQuery } from 'react-query';
import { fetcher } from '../../plugins/react-query';
import { Description, PageTitle } from '../../types';
import { tabSelectPageTitleState } from '../../plugins/ridge';

export const AtinMain = () => {
  const { push } = useHistory();
  tabSelectPageTitleState.set(PageTitle.ATIN);
  const pageTitle = tabSelectPageTitleState.useValue();
  const { data: description } = useQuery<Description>(
    `/descriptions?title=${pageTitle}`,
    fetcher
  );

  return (
    <>
      <TopBar text="ATIN" backButton />
      <div className="px-6">
        <FroalaEditorView model={description?.content} />
      </div>

      <FooterBar />

      <div className="pt-16">
        <Button
          type="button"
          text="예약하기"
          onClick={() => push('/reservation')}
          className="filled-brand-1 h-16 fixed bottom-20 w-full max-w-md"
        />
      </div>
    </>
  );
};
